<template>
  <p class="panel-title">{{ $t('app.campaign.newPage.recap.environmentSection.title') }}</p>
  <div v-if="currentCampaign" @keydown.enter="save" tabindex="0" class="environment-panel-content">
    <div class="environment">
      <div class="environment-header">
        <input name="env" type="radio" id="construction" value="construction_site" v-model="currentCampaign.assessment.environment"></input>
        <label for="construction">{{ $t('app.campaign.newPage.slidingPanel.environment.construction_site.title') }}</label>
      </div>
      <div class="environment-subtitle">{{ $t('app.campaign.newPage.slidingPanel.environment.construction_site.description') }}</div>
      <img src="@/assets/images/img/construction_site.png" class="environment-preview"></img>
    </div>
    <div class="environment">
      <div class="environment-header">
        <input name="env" type="radio" id="station" value="planet_station" v-model="currentCampaign.assessment.environment"></input>
        <label for="station">{{ $t('app.campaign.newPage.slidingPanel.environment.planet_station.title') }}</label>
      </div>
      <div class="environment-subtitle">{{ $t('app.campaign.newPage.slidingPanel.environment.planet_station.description') }}</div>
      <img src="@/assets/images/img/planetary_station.png" class="environment-preview"></img>
    </div>
  </div>
  <div class="edit-buttons">
    <Button class="secondary" :label="$t('app.campaign.newPage.slidingPanel.buttons.cancel')" @click="emit('close')"></Button>
    <Button class="green" :label="$t('app.campaign.newPage.slidingPanel.buttons.save')" @click="save"></Button>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.panel-title {
  color: var(--secondary-color);
  font-family: $bioSans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 32px;
}

.edit-buttons {
  margin-top: 32px;
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: end;
}

.environment-panel-content {
  display: flex;
  flex-direction: column;
  gap: 48px;

  .environment {
    display: flex;
    flex-direction: column;
    gap: 16px;

    flex-basis: 45%;
    flex-shrink: 1;
    flex-grow: 1;

    .environment-header {
      display: flex;
      gap: 8px;
    }

    .environment-subtitle {
      color: var(--secondary-color);
      font-family: $bioSans;
      font-size: 15px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      width: 40vw;
      text-wrap: wrap;
    }

    .environment-preview {
      border-radius: 6px;
      width: 300px;
      aspect-ratio: 16/9;
    }
  }
}
</style>

<script setup lang="ts">
import { CampaignCreation } from '@/stores/campaign';

const props = defineProps<{
  campaign: CampaignCreation,
}>();

const currentCampaign: Ref<CampaignCreation> = ref(undefined);

const emit = defineEmits<{
  (e: 'save', value: CampaignCreation),
  (e: 'valid', value: boolean): void,
  (e: 'close'): void,
}>();

function save() {
  emit('save', structuredClone(toRaw(currentCampaign.value)));
  emit('close');
}

onMounted(() => {
  currentCampaign.value = structuredClone(toRaw(props.campaign));
});

</script>